import dotPropImmutable from 'dot-prop-immutable';
import get from 'lodash/get';
import { DocumentResourceType, ResourceSectionType } from 'data/documents';
export const documentTemplateTaskSlice = {
    updateDocumentTemplateTask: (state, { payload })=>{
        var _sections_find;
        const { resourceSectionId, task, docId, resourceSectionName, resourceType } = payload;
        const sections = Object.values(dotPropImmutable.get(state, `${docId}.sections`, {}));
        const sectionId = (_sections_find = sections.find((section)=>{
            var _get;
            return (_get = get(section, 'meta.resourceSections')) === null || _get === void 0 ? void 0 : _get.includes(resourceSectionId);
        })) === null || _sections_find === void 0 ? void 0 : _sections_find.documentSectionId;
        const resourceSection = dotPropImmutable.get(state, `${docId}.resourceSections.${resourceSectionId}`, null);
        let result = state;
        if (resourceSection != null) {
            const resourceObjectIndex = (resourceSection.resourceObjects || []).findIndex((object)=>object.taskId === task.taskId);
            const resourceObjects = resourceObjectIndex > -1 ? (resourceSection.resourceObjects || []).map((object)=>object.taskId === task.taskId ? {
                    ...object,
                    ...task
                } : object) : [
                ...resourceSection.resourceObjects || [],
                task
            ];
            const resourceObjectIds = resourceObjects.map((object)=>object.taskId);
            result = dotPropImmutable.set(result, `${docId}.resourceSections.${resourceSectionId}.resourceIds`, resourceObjectIds);
            result = dotPropImmutable.set(result, `${docId}.resourceSections.${resourceSectionId}.resourceObjects`, resourceObjects);
        } else {
            const newResourceSection = {
                resourceSectionId,
                resourceSectionName,
                resourceSectionType: ResourceSectionType.Task,
                resourceType,
                resourceIds: [
                    task.taskId
                ],
                resourceObjects: [
                    task
                ]
            };
            result = dotPropImmutable.merge(result, `${docId}.sections.${sectionId}.meta.resourceSections`, [
                resourceSectionId
            ]);
            result = dotPropImmutable.merge(result, `${docId}.resourceSections.${resourceSectionId}`, newResourceSection);
        }
        return result;
    },
    deleteDocumentTemplateTask: (state, { payload })=>{
        const { docId, resourceSectionId, taskId } = payload;
        const path = `${docId}.resourceSections.${resourceSectionId}`;
        const resourceObjects = dotPropImmutable.get(state, `${path}.resourceObjects`, []);
        const result = dotPropImmutable.set(state, `${path}.resourceObjects`, resourceObjects.filter((object)=>object.taskId !== taskId));
        return dotPropImmutable.set(result, `${path}.resourceIds`, resourceObjects.map((object)=>object.taskId));
    },
    createDocumentTemplateHighlightTask: (state, { payload })=>{
        const { docId, resourceSectionId, sectionId, task } = payload;
        const newResourceSection = {
            resourceSectionId,
            resourceSectionName: 'Highlighted tasks',
            resourceSectionType: ResourceSectionType.Task,
            resourceType: DocumentResourceType.Highlight,
            resourceIds: [
                task.taskId
            ],
            resourceObjects: [
                task
            ]
        };
        let result = dotPropImmutable.merge(state, `${docId}.sections.${sectionId}.meta.resourceSections`, [
            resourceSectionId
        ]);
        result = dotPropImmutable.merge(result, `${docId}.resourceSections.${resourceSectionId}`, newResourceSection);
        return result;
    }
};
